export function dateFormater (date, fmt) {
  if (date === undefined || date === null || date === '') {
    return ''
  }
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

function formatJson (filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(i => v[i]))
}

export function toExcel (tabCols, tableData, name) {
  import('@/vendor/Export2Excel').then(excel => {
    const tHeader = ['序号'] // 表头
    const filterVal = ['index'] // 对应表格数据的字段名称
    // const tabCols = this.$refs.dataTable.columns
    for (const i in tabCols) {
      const col = tabCols[i]
      if (col.label !== undefined && tHeader.indexOf(col.label) < 0 && col.label !== '操作') {
        tHeader.push(col.label)
        if (col.property !== undefined) {
          filterVal.push(col.property)
        }
      }
    }
    const fileName = dateFormater(new Date(), 'yyyyMMddhhmmss') + name
    let list = tableData
    list.forEach((item, index) => {
      list[index].index = index + 1
    })
    const data = formatJson(filterVal, list)
    excel.export_json_to_excel(tHeader, data, fileName)
  })
}



// WEBPACK FOOTER //
// ./src/util/util.js